import React from 'react';
import Route from '../Route';

import Login from './Login.jsx';

const routes = new Route({
  path: '/login',
  noNav: true,
  action: function () {
    return <Login />;
  },
});

export default routes;
